export const AppUrls = {
  login: '/auth/login',
  logout: '/auth/logout',
  landing: '/auth/systems',
  notAuthorized: '/not-authorized',
  portalUsers: {
    props: { name: 'PortalUser' },
    list: '/Common/portalUsers'
  },
  country: {
    props: { name: 'Country' },
    list: '/navigation/data-management/countries'
  },
  cities: {
    props: { name: 'City' },
    list: '/data-management/cities'
  },
  userAccount: {
    props: { name: 'UserAccount' },
    list: '/data-management/UserAccount',
    create: '/data-management/UserAccount/create',
    details: '/data-management/UserAccount/details/'
  },
  arcoUserPosition: {
    props: { name: 'ArcoUserPosition' },
    list: '/data-management/userPosition',
    details: '/data-management/userPosition/details/',
    create: '/data-management/userPosition/create'
  },
  attachment: {
    props: { name: 'Attachment' },
    list: '/setup/attachments',
    attachment: '/setup/attachments/attachment'
  },
  documentTypes: {
    props: { name: 'DocumentTypes' },
    list: '/data-management/document-types',
    details: '/data-management/document-type/details/'
  },
  nationality: {
    props: { name: 'Nationality' },
    list: '/data-management/nationalities'
  },
  department: {
    props: { name: 'Department' },
    list: '/data-management/department',
    create:'/data-management/department/create',
    details:'/data-management/department/details/'
  },
  professions: {
    props: { name: 'Professions' },
    list: '/data-management/professions'
  },
  regions: {
    props: { name: 'Region' },
    list: '/data-management/regions'
  },
  religions: {
    props: { name: 'Religion' },
    list: '/data-management/religions'
  },
  projectManager: {
    props: { name: 'ProjectManager' },
    list: '/data-management/project-managers'
  },
  salesPerson: {
    props: { name: 'SalesPerson' },
    list: '/data-management/sales-persons'
  },
  contactPersons: {
    props: { name: 'ContactPerson' },
    list: '/data-management/contact-persons',
    viewContactPerson: '/navigation/sales/contracts/view-contract-person',
    sign: '/sales/contracts/sign'
  },
  contactPersonPositions: {
    props: { name: 'ContactPersonPosition' },
    list: '/data-management/contact-person-positions'

  },
  businessNature: {
    props: { name: 'CustomerBusinessNature' },
    list: '/data-management/business-nature'
  },
  businessSector: {
    props: { name: 'CustomerSector' },
    list: '/data-management/business-sectors'
  },
  leadSource: {
    props: { name: 'LeadSource' },
    list: '/data-management/leads-source'
  },
  leadRating: {
    props: { name: 'LeadRating' },
    list: '/data-management/leads-rating'
  },
  leadServiceType: {
    props: { name: 'LeadServiceType' },
    list: '/data-management/service-types'
  },
  interviewType: {
    props: { name: 'InterviewType' },
    list: '/data-management/interview-types'
  },
  arcoCertificateTypes: {
    props: { name: 'arcoCertificateTypes', icon: 'las la-recycle' },
    list: '/data-management/arco-certificate-types',
    create: '/data-management/arco-certificate-types/create',
    update: '/data-management/arco-certificate-types/update'
  },
  calculationField: {
    props: { name: 'CalculationField', icon: 'las la-chart-pie  ' },
    list: '/data-management/calculation-fields',
    details: '/navigation/data-management/calculation-fields/details/',
    edit: '/data-management/calculation-fields/update/'
  },
  calculationMethod: {
    props: { name: 'CalculationMethod', icon: 'las la-calculator  ' },
    list: '/data-management/calculation-methods',
    create: '/data-management/calculation-methods/create',
    details: '/data-management/calculation-methods/details'
  },
  salaryScale: {
    list: '/data-management/salary-scales',
    create: '/data-management/salary-scales/create',
    details: '/data-management/salary-scales/details',
    update: '/data-management/salary-scales/update'
  },
  serviceItemSetup: {
    list: '/data-management/service-item-setups',
    create: '/data-management/service-item-setup/create',
    details: '/data-management/service-item-setup/details',
    update: '/data-management/service-item-setup/update'
  },
  equations: {
    props: { name: 'CalculationEquation', icon: 'las la-calculator ' },
    list: '/data-management/equations',
    details: '/data-management/equations/details'
  },
  quotationSetup: {
    props: { name: 'CalculationEquation', icon: 'las la-cogs' },
    create: '/data-management/create-quotations-setup',
    update: '/data-management/edit-quotation-setup/',
    details: '/data-management/quotations-setup/details/'
  },
  transactionReasons: {
    props: { name: 'TransactionReason' },
    list: '/setup/transaction-reason',
    create: '/setup/transaction-reason/create',
    details: '/setup/transaction-reason/details'
  },

};
